// CleverTap/DataLayer constants for Pay Later via MTF (CLP_TRADING_MALL_CT_me.csv)
// component_id: pay_later_via_mtf | component_name: stocks_market_card_sku_details

export const PAY_LATER_MTF_COMPONENT_NAME = "stocks_market_card_sku_details";

export const PAY_LATER_MTF_CLICK_TYPE_LINK =
  "stocks_market_card_sku_details_link_click";

export const PAY_LATER_MTF_CLICK_TYPE_CARD =
  "stocks_market_card_sku_details_card_click";

export const PAY_LATER_MTF_REFERENCE_ID = "pay_later_via_mtf";

export const PAY_LATER_MTF_PRODUCT_CATEGORY = "stocks";

export const PAY_LATER_MTF_PROPERTY_TYPE = "clp";

export const PAY_LATER_MTF_PRODUCT_NAME = "pay later via mtf - trading mall";

export const PAY_LATER_MTF_ENTRY_POINT = "horizontal/entrypoint";

export const PAY_LATER_MTF_JOURNEY_TAG = "Demat";

export const PAY_LATER_MTF_CAMPAIGN = "DPAOP3| May";

export const PAY_LATER_MTF_SPRINT = "DPAOP3| May";
